export const HIERARCHY_AUDIT_ACTIONS = [
  "NODE_CREATED",
  "NODE_UPDATED",
  "NODE_STARTED",
  "NODE_DELETED",
  "NODE_CLOSED",
  "NODE_REOPENED",
  "IMPORT_APPLIED",
  "REPORT_GENERATED",
  "ASSIGNMENT_REPLACED",
  "PROGRESS_SUBMITTED",
  "APPROVAL_DECIDED",
  "NODE_FRAMEWORK_LINKED",
  "NODE_FRAMEWORK_UNLINKED",
  "FRAMEWORK_CREATED",
  "FRAMEWORK_UPDATED",
  "FRAMEWORK_DELETED"
];

export const AUDIT_ACTION_LABELS = {
  NODE_CREATED: "Node created",
  NODE_UPDATED: "Node updated",
  NODE_STARTED: "Task started",
  NODE_DELETED: "Node deleted",
  NODE_CLOSED: "Node closed",
  NODE_REOPENED: "Node reopened",
  IMPORT_APPLIED: "Import applied",
  REPORT_GENERATED: "Report generated",
  ASSIGNMENT_REPLACED: "Assignments updated",
  PROGRESS_SUBMITTED: "Progress submitted",
  APPROVAL_DECIDED: "Approval decided",
  NODE_FRAMEWORK_LINKED: "Framework linked",
  NODE_FRAMEWORK_UNLINKED: "Framework unlinked",
  FRAMEWORK_CREATED: "Framework created",
  FRAMEWORK_UPDATED: "Framework updated",
  FRAMEWORK_DELETED: "Framework deleted"
};

export const AUDIT_ENTITY_TYPE_LABELS = {
  GOAL_NODE: "Goal / Node",
  ASSIGNMENT: "Assignment",
  APPROVAL: "Approval",
  BUDGET: "Budget",
  EVIDENCE: "Evidence",
  SESSION: "Session",
  REPORT: "Report",
  FRAMEWORK: "Framework",
  UNKNOWN: "Unknown"
};

/** Derive Audit History "entity type" column — not from API */
export const actionToEntityType = (action) => {
  if (!action) {
    return "UNKNOWN";
  }
  if (action.startsWith("NODE_") || action === "IMPORT_APPLIED" || action === "REPORT_GENERATED") {
    return "GOAL_NODE";
  }
  if (action === "ASSIGNMENT_REPLACED") {
    return "ASSIGNMENT";
  }
  if (action === "PROGRESS_SUBMITTED" || action === "APPROVAL_DECIDED") {
    return "APPROVAL";
  }
  if (action.startsWith("FRAMEWORK_")) {
    return "FRAMEWORK";
  }
  return "UNKNOWN";
};
